export const CONFIRMATION = '/confirmation/:id';
